<template>
  <div v-if="showFooter">
    <div class="web-v footer-bottom">
      <div v-if="!mobileView" class="bottombar">
        <div class="left-items" @click="openMobileSearch">
          <router-link to="/">
            <img
              class="logo-img"
              alt="Khaanpin"
              src="@/assets/khaanpin3-red-full.png"
            />
            <!-- <div>{{ this.showSearchSuggestion }}</div> -->
          </router-link>

          <div class="searchbox">
            <form @submit.prevent="handleSearch" class="from__wrapper">
              <input
                class="search-input"
                placeholder="Search"
                v-model="searchText"
                @click="getSearchData()"
                @keydown.up="onArrowUp"
                @keyup.down="onArrowDown"
                @keydown.enter="onEnter"
              />
              <div
                class="footerbar__showSuggestion"
                v-if="showSearchSuggestion"
              >
                <img
                  :src="require('../../assets/svg/crossBlack.svg')"
                  alt="cross"
                  @click="handleClose()"
                />
                <span
                  v-for="item in searchFound.slice(0, 10)"
                  :class="
                    item.id == arrowCounter
                      ? 'search__suggestionActive'
                      : 'search__suggestionSpan'
                  "
                  :key="item.id"
                  @click="handleSearch(item.name)"
                  >{{ item.name }}</span
                >
              </div>
            </form>
            <a-icon
              type="search"
              class="search-icon"
              v-if="!showSearchLoading"
            />
            <div class="search-icon" v-if="showSearchLoading">
              <Loading />
            </div>
          </div>
        </div>

        <div class="right-items">
          <!-- <div class="image-wrapper" @click="showDrawer2"> -->

          <div class="image-wrapper" @click="onCart()">
            <a-badge :count="cartQuantity">
              <img class="cart-img" alt="Cart" src="@/assets/cart.png" />
              <!-- <span class="cartsize">{{ cartQuantity }}</span> -->
            </a-badge>
          </div>

          <div class="total-price">NRs {{ cartTotal }}*/-</div>

          <a-button
            type="primary"
            @click="onCheckout"
            v-if="cartTotal > 0"
            class="checkout-button"
          >
            Place Order →
          </a-button>
        </div>
      </div>

      <!-- so mobile view -->
      <div v-else class="bottombar">
        <div v-if="!mobileSearch" class="left-items">
          <router-link to="/">
            <img
              class="logo-img-mini"
              alt="Khaanpin"
              src="@/assets/logo-mini.png"
            />
          </router-link>

          <div class="searchbox" @click="openMobileSearch">
            <a-icon type="search" class="m-search-icon" />
          </div>
        </div>

        <div v-if="!mobileSearch" class="right-items">
          <!-- <div class="image-wrapper" @click="showDrawer2"> -->
          <div @click="onCart()" class="image-wrapper">
            <!-- <img class="cart-img-mobile" alt="Cart" src="@/assets/cart.png" /> -->
            <a-badge :count="cartQuantity">
              <img class="cart-img" alt="Cart" src="@/assets/cart.png" />
              <!-- <span class="cartsize">{{ cartQuantity }}</span> -->
            </a-badge>
            <!-- <span class="cartsize">{{ cartQuantity }} </span> -->
          </div>

          <div class="total-price">NRs {{ cartTotal }}*/-</div>

          <a-button
            type="primary"
            @click="onCheckout"
            v-if="cartTotal > 0"
            class="checkout-button"
          >
            Place Order →
          </a-button>
        </div>

        <div v-else class="ms-wrapper">
          <form class="ms-form" @submit.prevent="handleSearch">
            <input
              autofocus
              class="ms-input"
              placeholder="Search Here"
              v-model="searchText"
            />
          </form>

          <div class="close-wrapper" @click="closeMobileSearch">
            <a-icon type="close" class="close-icon" />
          </div>
        </div>
      </div>
      <!-- eo mobile view -->
    </div>

    <a-drawer
      placement="right"
      :width="520"
      :closable="false"
      @close="onClose"
      :visible="visible2"
    >
      <div class="drawer-content cart-content">
        <div class="cross">
          <div class="img-wrap" @click="onClose">
            <img src="../../assets/images/multiply.svg" alt="close" />
          </div>
        </div>
        <Cart v-on:close-drawer="onClose" />
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { LocationId } from "../../services/storage.service";
import router from "../../router";
import isEmpty from "../../utils/isEmpty";
import Cart from "../../components/Header/Cart.vue";
import axios from "axios";
import Loading from "../../components/Loading/Loading.vue";

export default {
  name: "FooterBar",
  components: {
    Cart,
    Loading,
  },
  data() {
    return {
      arrowCounter: -1,

      visible2: false,
      visibleOrders: 0,
      cartQuantity: 0,
      showFooter: false,
      searchText: "",
      mobileView: false,
      mobileSearch: false,
      searchItems: [],
      searchFound: null,
      showSearchSuggestion: false,
      showSearchLoading: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  created() {
    window.addEventListener("resize", this.handleWindowResize);
    this.handleWindowResize();

    if (!isEmpty(this.loggedUser)) {
      if (this.loggedUser.hasOwnProperty("first_name")) {
        this.name = this.loggedUser.first_name;
      }
    }
    let quantity = this.cartItems.reduce((acc, item) => acc + item.quantity, 0);
    this.cartQuantity = quantity;
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
  watch: {
    loggedUser: function (val) {
      if (val.hasOwnProperty("first_name")) {
        this.name = val.first_name;
      }
    },
    cartItems: function (val) {
      let quantity = val.reduce((acc, item) => acc + item.quantity, 0);
      this.cartQuantity = quantity;
    },
    isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    searchText() {
      this.getSearchData();
    },
  },
  computed: {
    ...mapGetters(["cartItems", "cartTotal"]),
  },
  methods: {
    handleClose(event) {
      // event.preventFocus();
      this.searchText = "";
      this.showSearchSuggestion = false;
      this.showSearchLoading = false;
    },

    onArrowDown() {
      if (this.arrowCounter < this.searchFound.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },

    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      this.showSearchSuggestion = false;

      this._search = this.searchFound[this.arrowCounter];
      this.searchText = this._search.name;
      this.arrowCounter = -1;
    },

    getSearchData() {
      this.showSearchLoading = true;

      const _data = {
        loc_id: JSON.stringify(LocationId.getLocationId()),
        search: this.searchText,
      };

      axios
        .post("https://deus.khaanpin.com/appapi/top/search/", _data)
        .then((response) => {
          this.searchItems = response.data.data;

          const data = response.data.data.forEach((item, i) => {
            item.id = i;
          });
          this.searchFound = response.data.data;
          this.showSearchSuggestion = true;
          this.showSearchLoading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    showDrawer2() {
      this.visible2 = true;
    },
    onClose() {
      this.visible2 = false;
      this.visibleOrders = 0;
    },
    onCheckout() {
      router.push("/p/order");
    },
    onScroll() {
      this.windowTop = window.top.scrollY;

      if (this.windowTop >= 200) {
        this.showFooter = true;
        this.showSearchSuggestion = false;
      } else if (this.windowTop <= 200) {
        this.showFooter = false;
      }
    },
    handleSearch: function (item) {
      this.showSearchSuggestion = false;

      if (LocationId.getLocationId() == 1) {
        this.$router.replace({
          name: "Search",
          params: { loc: "ktm" },
          query: { q: this.searchText || item },
        });
      } else if (LocationId.getLocationId() == 2) {
        this.$router.replace({
          name: "Search",
          params: { loc: "pkr" },
          query: { q: this.searchText || item },
        });
      }

      this.searchText = "";
    },
    closeMobileSearch: function () {
      this.mobileSearch = false;
    },
    openMobileSearch: function () {
      // console.log("click click")
      this.mobileSearch = true;
    },
    handleWindowResize() {
      if (window.innerWidth <= 720) {
        this.mobileView = true;
      } else {
        this.mobileView = false;
      }
    },
    onCart() {
      router.push("/p/order");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.from__wrapper {
  position: relative;
}

.footbar__searchLoading {
  position: absolute;
}

.footerbar__showSuggestion {
  display: flex;
  flex-direction: column;
  position: fixed;
  justify-content: flex-end;
  bottom: 70%;
  // border : 1px solid black;
  background: #fff;
  // height: 150px;
  width: 40%;
  z-index: 999999;
}

.footerbar__showSuggestion > img {
  height: 15px;
  margin-right: 10px;
  margin-top: 8px;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}

.search__suggestionSpan {
  /* color: red; */
  color: #4b4b4b;
  /* margin: 2px 0; */
  letter-spacing: 0.6px;
  font-size: 14px;
  padding: 5px 25px;
  font-weight: bolder;

  font-family: "Montserrat", sans-serif;
}

.search__suggestionActive {
  color: #000000;
  background-color: #e2e2e2;

  letter-spacing: 0.6px;
  font-size: 14px;
  padding: 5px 25px;
  font-weight: bolder;

  font-family: "Montserrat", sans-serif;
}

.search__suggestionSpan:hover {
  color: black;
  background-color: #e2e2e2;
}

.footer-bottom {
  background: rgba(255, 255, 255, 1);
  transition: bottom 0.4s;
  &.web-v {
    position: fixed;
    width: 90%;
    transform: translateX(-50%);
    margin-left: 50%;
    bottom: 20px;
    z-index: 99;
    border-radius: 10px;
    box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);
  }
}

.bottombar {
  width: 100%;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.left-items {
  width: 50%;
  display: flex;
  align-items: center;
}

.right-items {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .image-wrapper {
    // display: inline-block;
    position: relative;
    cursor: pointer;

    .cartsize {
      position: absolute;
      top: 0px;
      right: -5px;
      border-radius: 50%;
    }
  }
}

.total-price {
  display: inline-block;
  margin: 0px 10px;
  font-family: $main-font;
  // color: #27272f;
}

.checkout-button {
  display: inline-block;
  padding: 10px;
  background-color: $brand-color;
  color: white;
  height: auto;
  cursor: pointer;
  font-family: $main-font;
  text-transform: uppercase;
  border-radius: 4px;
}

.searchbox {
  position: relative;
  display: block;
  width: 100%;
  // max-width: 53px;
  transition: 0.4s linear;
  overflow: hidden;
  margin-left: 5px;

  .search-input {
    display: block;
    appearance: none;
    height: 38px;
    width: 100%;
    border: none;
    outline: none;
    padding: 15px;
    color: #27272f;
    font-size: 18px;
    cursor: pointer;
    transition: 0.4s linear;
    padding-left:30px;

    &::placeholder {
      color: transparent;
    }
  }

  .search-icon {
    position: absolute;
    left: -10px;
    top: 50%;
    transform: translate(50%, -50%);
    width: 20px;
    height: 20px;
    pointer-events: none;
    color: #27272f;
    font-size: 20px;
  }

  &:focus-within {
    max-width: 100%;
    border-bottom: 1px solid #27272f;
  }
}

.drawer-content {
  padding: 20px;
  .cross {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    .img-wrap {
      width: 18px;
    }
  }
  &.cart-content {
    padding: 15px 50px;

    .search-input {
      background-color: #fff;
      padding-right: 50px;
    }
  }
}

.ms-wrapper {
  position: relative;
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #27272f;

  .ms-form {
    display: flex;
    width: 100%;
    .ms-input {
      border: none;
      outline: none;
      width: 100%;
      font-size: 16px;
      color: #27272f;
      &::placeholder {
        color: #27272f;
      }
    }
  }

  .close-wrapper {
    cursor: pointer;
    .close-icon {
      width: 18px;
      height: 18px;
      pointer-events: none;
      color: #27272f;
      font-size: 18px;
      cursor: pointer;
    }
  }
}

.m-search-icon {
  width: 20px;
  height: 20px;
  pointer-events: none;
  color: #27272f;
  font-size: 20px;
  margin-left: 10px;
}

@media only screen and (max-width: 768px) {
  .header {
    display: block !important;
    a {
      display: block !important;
    }
    .button-icon {
      display: block !important;
    }
  }

  .header-wrap {
    .container {
      margin: 0;
      width: 100%;
    }
  }
  .header {
    .custom-menu {
      li {
        padding: 0 15px;
        a {
          font-size: 12px;
        }
      }
    }
  }
  .drawer-content {
    padding: 15px 20px 60px;
  }
}

@media only screen and (max-width: 425px) {
  .drawer-content {
    &.cart-content {
      padding: 15px 0px 30px;
    }
  }
}

.drawer-content.my-order {
  margin: 0 !important;
  padding: 0 !important;

  .cross {
    position: relative;
    top: -10px;
  }
}

.logo-img {
  height: 40px;
}

.logo-img-mini {
  width: 40px;
}

.cart-img {
  width: 30px;
}

.cart-img-mobile {
  width: 30px;
}
</style>
